import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { ArrowUpRightBlue, CapIconRed } from "../../constant/imagePath";
import Colors from "../../stories/assets/Colors";
import Fonts from "../../stories/assets/Fonts";
import { Button } from "../../stories/Button/Button";
import { LinkButtonWithIcon } from "../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { MobileHeader } from "../../stories/MobileHeader/MobileHeader";
import classes from "./WelcomePageMobile.module.css";

export default function WelcomePageMobile() {
  const [userType, setUserType] = useState("student");
  const history = useHistory();

  function redirectOnRoleBased() {
    userType === "student"
      ? history.push("/socialSignupStudent")
      : history.push("/socialSignupCoach");
  }
  return (
    <>
      <style jsx>{`
        .${classes.border} {
          border-left: 2px solid ${Colors.neutralShadesOfGainsboro};
        }
        .${classes.boxSelected} {
          border-left-color: ${Colors.mainBlue} !important;
        }
      `}</style>
      <div>
        <Container fluid className={classes.container}>
          <MobileHeader isAvatar={false} isLogo={true} />
          <Row
            style={{
              height: "100%",
            }}
          >
            <Col sm={12}>
              <Col
                sm={12}
                className={classes.mt52}
                onClick={() => setUserType("student")}
              >
                <div
                  className={` ${[
                    classes.box,
                    userType === "student"
                      ? classes.boxSelected
                      : classes.border,
                  ].join(" ")}`}
                >
                  <img src={CapIconRed} />
                  <h1
                    style={{
                      ...Fonts.h1,
                      color: Colors.neutralShadesOfNero,
                      fontSize: "29px",
                      lineHeight: "36px",
                    }}
                  >
                    I’m Student
                  </h1>
                  <p
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    I want to find a coach and book a training through this
                    service.
                  </p>
                </div>
              </Col>
              <Col
                sm={12}
                className={classes.mt48}
                onClick={() => setUserType("coach")}
              >
                <div
                  className={` ${[
                    classes.box,
                    userType === "coach" ? classes.boxSelected : classes.border,
                  ].join(" ")}`}
                >
                  <img src={CapIconRed} />
                  <h1
                    style={{
                      ...Fonts.h1,
                      color: Colors.neutralShadesOfNero,
                      fontSize: "29px",
                      lineHeight: "36px",
                    }}
                  >
                    I’m Coach
                  </h1>
                  <p
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    I want to do sports training and also get paid easily.
                  </p>
                </div>
              </Col>
              <Col sm={12} className={classes.mt52}>
                <Button
                  label={"Continue"}
                  size={"Large"}
                  primary={true}
                  onClick={redirectOnRoleBased}
                />
              </Col>
            </Col>
            <Col sm={12} className={classes.footerContainer}>
              {/* Already have account Login for mobile  */}
              <div className={classes.alreadyHaveAccountForMobile}>
                <p
                  style={{
                    ...Fonts.p2,
                    color: Colors.neutralShadesOfDimGray,
                  }}
                >
                  Already have an account?
                </p>
                <LinkButtonWithIcon
                  primary={true}
                  text={"Log in"}
                  rightIcon={ArrowUpRightBlue}
                  iconStyle={{ margin: "0px" }}
                  onClick={() => history.push("/login")}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
